import { render, staticRenderFns } from "./informacionEstudiante.vue?vue&type=template&id=21b2d5dc"
import script from "./informacionEstudiante.vue?vue&type=script&lang=js"
export * from "./informacionEstudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports